import { DEFAULT_STATE, GameState } from './GameState';
import { loadSaveAsync, persistSaveAsync } from './persistDb';
import { bookCatalog } from '@/data/bookCatalog';
import { MANUS_PER_DAG } from '@/config';

export const gameState = new GameState({ ...DEFAULT_STATE });

gameState.setManusProvider(bookCatalog, MANUS_PER_DAG);

let saveTimer: number | undefined;
let saveSubscribed = false;

function abonnerPaaPersist(): void {
  if (saveSubscribed) return;
  saveSubscribed = true;
  gameState.subscribe((snap) => {
    if (typeof window === 'undefined') return;
    if (saveTimer !== undefined) window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(() => {
      void persistSaveAsync(snap);
    }, 150);
  });
}

let initPromise: Promise<void> | null = null;

export function initStoreAsync(): Promise<void> {
  if (initPromise) return initPromise;
  initPromise = (async () => {
    try {
      const saved = await Promise.race([
        loadSaveAsync(),
        new Promise<typeof DEFAULT_STATE>((resolve) =>
          setTimeout(() => resolve({ ...DEFAULT_STATE }), 5000),
        ),
      ]);
      if (saved.version === 1) {
        gameState.applySaveSnapshot(saved);
      }
    } catch (err) {
      console.warn('Save-lasting feilet, starter med default-state', err);
    }
    abonnerPaaPersist();
  })();
  return initPromise;
}
